import { graphql } from "react-relay";

import "@components/avatar-row-new/AvatarRow.gql";
import { ZoomSettings } from "@components/zoom-settings";

export const orgSettingsFragments = {
  user: graphql`
    fragment OrgSettings_user on User {
      ...ZoomSettings_user
    }
  `,
  org: graphql`
    fragment OrgSettings_org on Org {
      id
      domains
      primaryOrgCalendar
      ...ZoomSettings_org
      ...AvatarRowNew_org
      currentOrgPersons {
        __typename
        ... on OrgPersonList {
          list {
            ...AvatarPerson_orgPerson
            primaryCalendarId
            userId
            personId
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};

export const query = graphql`
  query OrgSettingsQuery {
    viewer {
      id
      user {
        ...OrgSettings_user
        orgs(first: 1000000) {
          edges {
            node {
              ...OrgSettings_org
            }
          }
        }
      }
    }
  }
`;
